import { createStyles } from '@codeleap/styles'
import { StyleRegistry } from '../styles'

export type ImageComposition = 'wrapper'

const createImageVariant = createStyles<ImageComposition>

export const ImageStyles = {
  default: createImageVariant(() => ({
    wrapper: {
      position: 'relative',
      overflow: 'hidden'
    },
  })),
  skeleton: createImageVariant(theme => ({
    wrapper: {
      backgroundColor: theme.baseColors.neutralSolid200,
    },
  })),
  round: createImageVariant(theme => ({
    wrapper: {
      borderRadius: theme.radius.infinite,
    },
  })),
}

StyleRegistry.registerVariants('Image', ImageStyles)
